import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-credit-memo-approval',
    templateUrl: './credit-memo-approval.component.html',
    styleUrls: ['./credit-memo-approval.component.scss']
})
export class CreditMemoApprovalComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.creditMemoApproval;
    chartSearchFilters: widgetFilters[] = [
        widgetFilters.divisions,
        widgetFilters.disputeAmmount,
        widgetFilters.creditMemoStatus,
        widgetFilters.creditReasonCode,
        widgetFilters.onCallRegion,
        widgetFilters.regions
    ];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        //the chart should never filter on status, so when the details grid
        //sets this parameter we should clear it on chart load
        searchParams.out_S = null;
        this.searchParams.emit(searchParams);
    }
}
